import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Rooms from './components/Rooms';
import Amenities from './components/Amenities';
import Experiences from './components/Experiences';
import Gallery from './components/Gallery';
import Offers from './components/Offers';
import BookingBenefits from './components/BookingBenefits';
import Map from './components/Map';
import StickyBooking from './components/StickyBooking';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-luxury-beige selection:bg-primary/20 selection:text-primary-dark">
      <Navbar />
      <main>
        <Hero />
        <Rooms />
        <BookingBenefits />
        <Gallery />
        <Amenities />
        <Experiences />
        <Offers />
        <Testimonials />
        <Map />
        <Contact />
      </main>
      <StickyBooking />
      <Footer />
    </div>
  );
}

export default App;
